type TargetValueEvent = {
  target: {
    name: string
    value: string | number
  }
}

export const mountEvent = (
  name: string,
  value: any
): TargetValueEvent => {
  const event = {
    target: {
      name,
      value
    }
  }

  return event
}


export const formatBooleanInput = (value: boolean | undefined) => {
  if (value === true) {
    return  'yes'
  } else if (value === false) {
    return 'no'
  }

  return ''
}
